import { useEffect, useState } from "react";
import FormFactory from "../../../../../components/FormFactory";
import InputFactory from "../../../../../components/InputFactory";

const schema = {
  fields: {
    username: {
      label: "Username",
      type: "String",
      field: "username",
      placeholder: "Enter Username",
      lowercase: true,
      required: true,
      section: "credentials",
    },
    email: {
      label: "Email",
      type: "Email",
      field: "email",
      placeholder: "Enter Password",
      required: true,
      section: "credentials",
    },
    password: {
      label: "Password",
      type: "Password",
      field: "password",
      placeholder: "Enter Password",
      required: true,
      section: "credentials",
    },
    reEnterPassword: {
      label: "Confirm Password",
      type: "Password",
      field: "reEnterPassword",
      placeholder: "Re-enter Password",
      required: true,
      section: "credentials",
    },
  },
  sections: {
    credentials: {
      label: "Credentials",
      description: "Credentials for the client",
      icon: "bi bi-key",
    },
  },
};

function CredentialForm({ onChange, formData }) {
  const [formDatas, setFormDatas] = useState({ roles: [{ id: "Client" }] });

  const _onChange = (value, field) => {
    onChange(value, field);
  };

  useEffect(() => {
    onChange(formDatas, "user");
  }, [formDatas]);

  const handleChange = (value, field) => {
    setFormDatas((prev) => ({ ...prev, [field]: value }));
  };

  let isPasswordMatch = formDatas.password === formDatas.reEnterPassword;
  let passwordsNotNull = formDatas.password && formDatas.reEnterPassword;

  return (
    <>
      <div className="">
        <div className="flex flex-column">
          <FormFactory
            object={formDatas}
            indicatorClass={
              isPasswordMatch && passwordsNotNull
                ? "border-success bg-success bg-opacity-10"
                : "border-dark-subtle bg-white"
            }
            schema={schema}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
}

export default CredentialForm;
